import {
    STORE_USER_CONFIGURATION,
    UPDATE_BIDDING_USER_CONFIGURATION,
} from '../../actions/userConfiguration';

export const defaultState = {
    defaultPrice: null,
    defaultQuantity: null,
    priceStep: null,
    quantityStep: null,
    allowedBiddingTypes: [],
};

const bidding = (state = defaultState, action = undefined) => {
    switch (action.type) {
        case STORE_USER_CONFIGURATION:
            return action.payload.bidding ? {
                defaultPrice: action.payload.bidding.defaultPrice,
                defaultQuantity: action.payload.bidding.defaultQuantity,
                priceStep: action.payload.bidding.priceStep,
                quantityStep: action.payload.bidding.quantityStep,
                allowedBiddingTypes: action.payload.bidding.allowedBiddingTypes,
            } : state;
        case UPDATE_BIDDING_USER_CONFIGURATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default bidding;
